import { api, apiClient } from '@/lib/axios'
import type { BrandVoice, CreateBrandVoiceDto, UpdateBrandVoiceDto } from '../types/brand-voice.types'

export async function getBrandVoices(): Promise<BrandVoice[]> {
  const response = await api.get<BrandVoice[]>('/api/brand-voices')
  if (!response.success) throw new Error(response.error.message)
  return response.data
}

export async function getBrandVoiceById(id: string): Promise<BrandVoice> {
  const response = await api.get<BrandVoice>(`/api/brand-voices/${id}`)
  if (!response.success) throw new Error(response.error.message)
  return response.data
}

export async function createBrandVoice(data: CreateBrandVoiceDto): Promise<BrandVoice> {
  const response = await api.post<BrandVoice>('/api/brand-voices', data)
  if (!response.success) throw new Error(response.error.message)
  return response.data
}

export async function updateBrandVoice(
  id: string,
  data: UpdateBrandVoiceDto,
): Promise<BrandVoice> {
  const response = await api.patch<BrandVoice>(`/api/brand-voices/${id}`, data)
  if (!response.success) throw new Error(response.error.message)
  return response.data
}

export async function deleteBrandVoice(id: string): Promise<void> {
  await apiClient.delete(`/api/brand-voices/${id}`)
}

export async function duplicateBrandVoice(id: string): Promise<BrandVoice> {
  const response = await api.post<BrandVoice>(`/api/brand-voices/${id}/duplicate`)
  if (!response.success) throw new Error(response.error.message)
  return response.data
}
